










































import { Component, Vue } from 'vue-property-decorator'

import menuConfig from '@/config/slideMenuConfig'

interface IMenuConfig {
  title: string,
  collapse: Boolean,
  items: Array<IMenuItem>
}

interface IMenuItem {
  key: string,
  text: string,
  icon: string
}

@Component({
  name: 'AppSide'
})
export default class AppSide extends Vue {
  private menuData: Array<IMenuConfig> = menuConfig

  private menuDrag (e: any, key: string) {
    e.dataTransfer.setData('cmp-type', key)
  }
}
